<nav class="nav nav--home">
  <div class="nav-inner nav-inner--home">
    <input type="checkbox" id="nav-menu-toggle" class="nav-menu-cb" aria-hidden="true" tabindex="-1" />

    <a class="nav-logo nav-logo--compact" routerLink="/home" (click)="closeMobileMenu()">
      <img
        class="nav-logo-img"
        src="/brand-logo.png"
        alt="Africa Tamilcharal"
        width="220"
        height="48"
        decoding="async"
      />
    </a>

    <div class="nav-links" id="primary-navigation">
      <a class="nav-link" routerLink="/home" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.HOME' | translate }}</a>
      <a class="nav-link" routerLink="/magazine" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.MAGAZINE' | translate }}</a>
      <a class="nav-link" routerLink="/books" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.BOOKS' | translate }}</a>
      <a class="nav-link" routerLink="/authors" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.AUTHORS' | translate }}</a>
      <a class="nav-link" routerLink="/events" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.EVENTS' | translate }}</a>
      @if (authService.currentUser()) {
        <a class="nav-link nav-link--extra" routerLink="/orders" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.ORDERS' | translate }}</a>
      }
      @if (authService.isAdmin()) {
        <a class="nav-link nav-link--extra" routerLink="/admin" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'NAV.ADMIN' | translate }}</a>
      }
    </div>

    <div class="nav-end-cluster">
      <form class="nav-search" (submit)="onSearch($event)" role="search" autocomplete="off">
        <input
          type="text"
          name="storefront-search"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          [placeholder]="'NAV.SEARCH_PLACEHOLDER' | translate"
          [value]="searchQuery()"
          (input)="onNavSearchInput($any($event.target).value)"
          [attr.aria-label]="'NAV.SEARCH' | translate"
        />
        <button type="submit" class="nav-search-btn" [attr.aria-label]="'NAV.SEARCH' | translate">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
          </svg>
        </button>
      </form>

      <div class="nav-lang" role="group" [attr.aria-label]="'Language'">
        <button
          type="button"
          class="nav-lang-btn"
          [class.active]="language.lang() === 'en'"
          (click)="setLang('en')"
        >EN</button>
        <button
          type="button"
          class="nav-lang-btn"
          [class.active]="language.lang() === 'ta'"
          (click)="setLang('ta')"
        >TA</button>
      </div>

      <button type="button" class="nav-icon-btn" [title]="'NAV.NOTIFICATIONS' | translate" [attr.aria-label]="'NAV.NOTIFICATIONS' | translate" (click)="openNotifications()">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M18 8a6 6 0 10-12 0c0 7-3 7-3 7h18s-3 0-3-7"/><path d="M13.7 21a2 2 0 01-3.4 0"/>
        </svg>
      </button>

      <div class="nav-actions">
        <button type="button" class="nav-cart-btn nav-cart-btn--quiet" id="nav-cart-target" (click)="cartOpen.emit()" [title]="'NAV.CART' | translate" [attr.aria-label]="'NAV.CART' | translate">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
          </svg>
          @if (cartCount() > 0) {
            <span class="nav-cart-badge">{{ cartCount() }}</span>
          }
        </button>

        @if (authService.currentUser(); as user) {
          <div class="nav-profile" [class.open]="profileOpen()">
            <button type="button" class="nav-profile-btn" (click)="toggleProfile()" aria-haspopup="menu" [attr.aria-expanded]="profileOpen()">
              <span class="nav-user-avatar" aria-hidden="true">
                @if (profilePhoto(); as photo) {
                  <img [src]="photo" alt="" />
                } @else {
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                  </svg>
                }
              </span>
              <span class="nav-user-name">{{ user.UsrFullName.split(' ')[0] }}</span>
              <span class="nav-chevron" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
              </span>
            </button>
            @if (profileOpen()) {
              <div class="nav-profile-menu" role="menu" @dropdownFade>
                <a routerLink="/profile" role="menuitem" (click)="profileOpen.set(false)">{{ 'NAV.PROFILE' | translate }}</a>
                <a routerLink="/wishlist" role="menuitem" (click)="profileOpen.set(false)">{{ 'NAV.WISHLIST' | translate }}</a>
                <a routerLink="/orders" role="menuitem" (click)="profileOpen.set(false)">{{ 'NAV.ORDERS' | translate }}</a>
                <button type="button" role="menuitem" (click)="requestLogout()">{{ 'NAV.SIGN_OUT' | translate }}</button>
              </div>
            }
          </div>
        } @else {
          <button type="button" class="nav-profile-btn" (click)="authOpen.emit()">
            <span class="nav-user-avatar" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </span>
            <span class="nav-user-name">{{ 'NAV.SIGN_IN' | translate }}</span>
          </button>
        }
      </div>

      <label for="nav-menu-toggle" class="nav-burger" [attr.aria-label]="'NAV.MENU' | translate">
        <span class="nav-burger-bar"></span>
        <span class="nav-burger-bar"></span>
        <span class="nav-burger-bar"></span>
      </label>
    </div>
  </div>
</nav>

@if (logoutConfirmOpen()) {
  <div class="app-confirm-overlay" (click)="cancelLogout()">
    <div class="app-confirm" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="signout-title">
      <button type="button" class="app-confirm__close" (click)="cancelLogout()" aria-label="Close">×</button>
      <div class="app-confirm__icon is-leave" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
      </div>
      <h3 id="signout-title" class="app-confirm__title">{{ 'NAV.SIGN_OUT_TITLE' | translate }}</h3>
      <p class="app-confirm__msg">{{ 'NAV.SIGN_OUT_MSG' | translate }}</p>
      <div class="app-confirm__actions">
        <button type="button" class="app-confirm__btn app-confirm__btn--ghost" (click)="cancelLogout()">{{ 'NAV.CANCEL' | translate }}</button>
        <button type="button" class="app-confirm__btn app-confirm__btn--primary" (click)="confirmLogout()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          {{ 'NAV.SIGN_OUT' | translate }}
        </button>
      </div>
    </div>
  </div>
}
